import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, size = 'md' }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  };

    return (    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">      {/* Backdrop */}      <div         className="absolute inset-0 bg-black/50 backdrop-blur-sm animate-fade-in"        onClick={onClose}      />            {/* Modal */}      <div className={`relative bg-white rounded-2xl shadow-lifted w-full max-h-[90vh] overflow-auto ${sizeClasses[size]} animate-scale-in`}>        {/* Header */}        <div className="flex items-center justify-between p-6 border-b border-primary-100 sticky top-0 bg-white rounded-t-2xl">          <h2 className="text-2xl font-display font-semibold">{title}</h2>          <button            onClick={onClose}            className="p-2 hover:bg-primary-50 rounded-lg transition-colors"          >            <X size={20} />          </button>        </div>                {/* Content */}        <div className="p-6">          {children}        </div>      </div>    </div>  );
};

export default Modal; 